export default __webpack_public_path__ + "assets/14.1d085cdc.png";